/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { ContinuousDorna } from "./modelContinuousDorna";

class ControllerContinuousDorna extends ControllerModel {
  constructor() {
    super("ContinuousDorna");

    this.setNewNode = (callback) => {
      let continuousDorna = new ContinuousDorna();
      continuousDorna.decorate(callback);

      this.addNode(continuousDorna);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let continuousDorna = new ContinuousDorna();
      continuousDorna.copyFrom(node);
      continuousDorna.decorate(callback);
      this.addNode(continuousDorna);
    };

    this.getProperties = async (node) => {
      let n = new ContinuousDorna();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new ContinuousDorna();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerContinuousDorna };
